<template>
  <div>
    <v-row>
      <v-col cols="6" sm="3">
        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
          {{ $t("Today") }}
        </v-btn>
      </v-col>
      <v-col cols="6" sm="9">
        <div class="display-flex">
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small v-if="locale == 'ar'">mdi-chevron-right</v-icon>
            <v-icon small v-if="locale == 'en'">mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title class="mt-1" v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small v-if="locale == 'ar'">mdi-chevron-left</v-icon>
            <v-icon small v-if="locale == 'en'">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-sheet height="600">
      <v-calendar
        ref="calendar"
        v-model="focus"
        :now="today"
        :value="today"
        :events="events"
        color="primary"
        @click:event="showEvent"
        type="week"
        :event-color="getEventColor"
        :class="locale == 'en' ? 'calendar-ltr' : 'calendar-rtl'"
      ></v-calendar>
      <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :activator="selectedElement"
        offset-x
      >
        <v-card color="grey lighten-4" min-width="350px" flat>
          <v-toolbar :color="selectedEvent.color" dark>
            <v-btn icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <span v-html="selectedEvent.details"></span>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="secondary" @click="selectedOpen = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-sheet>

    <!-- dialog select subject -->
    <v-dialog v-model="selectSubjectDialog" max-width="500">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="closeSelectSubjectDialog()">
            <v-icon class="main-color">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color">{{
          $t("Reserve meeting")
        }}</v-card-title>

        <div>
          <v-container style="padding: 1rem !important">
            <div v-if="scheduleMessage != ''" style="text-align: center">
              <p class="alert" style="color: red">{{ scheduleMessage }}</p>
            </div>
            <div class="teacher-info text-center">
              <img
                :src="
                  teacher.img
                    ? teacher.img
                    : teacher.title == 'mr'
                    ? defaultAvaterMale
                    : defaultAvaterfeMale
                "
                class="teacher-image"
                style="cursor: pointer"
                alt
              />

              <p class="main-color">{{ teacher.name }}</p>
            </div>
            <v-form v-model="valid" ref="form">
              <v-row>
                <v-col cols="12" sm="6">
                  <label for="from">{{ $t("From") }} *</label>
                  <v-select
                    v-model="reserveObject.start"
                    :items="startItems"
                    :rules="[validationRules.required]"
                    solo
                    dense
                    chips
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <label for="to">{{ $t("To") }} *</label>
                  <v-select
                    v-model="reserveObject.end"
                    :items="endItems"
                    :rules="[validationRules.required]"
                    solo
                    dense
                    chips
                  ></v-select>
                  <!-- :items="" -->
                </v-col>
                <v-col cols="12" sm="12">
                  <label for="subjects" class="main-color">{{
                    $t("Choose Subject")
                  }}</label>
                  <v-select
                    :items="subjects"
                    item-text="name"
                    item-value="id"
                    solo
                    chips
                    v-model="reserveObject.subject_id"
                    :rules="[validationRules.required]"
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12">
                  <label for="title" class="main-color">
                    {{
                      $t(
                        "What is the title you would like to study with teach ?"
                      )
                    }}
                  </label>
                  <v-textarea
                    v-model="reserveObject.notes"
                    solo
                    dense
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="modal-btn">
            <v-col cols="6" sm="6">
              <v-btn
                class="primary-btn text-right"
                text
                @click="closeSelectSubjectDialog()"
                >{{ $t("Cancel") }}</v-btn
              >
            </v-col>
            <v-col cols="6" sm="6" class="text-left">
              <v-btn class="primary-btn" text @click="goNext">
                {{ $t("Continue") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- confirm dialog -->
    <v-dialog v-model="confirmReservationDialog" max-width="500">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="closeConfirmReservationDialog()">
            <v-icon class="main-color">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color">{{
          $t("confirmAppointment")
        }}</v-card-title>

        <div>
          <v-container style="padding: 1rem !important">
            <v-row>
              <v-col>
                <p class="main-color">
                  <strong>{{ $t("teacherName") }} :</strong>
                  <span class="grey--text darken-1">{{ teacher.name }}</span>
                </p>
                <p class="main-color">
                  <strong>{{ $t("subject") }} :</strong>
                  <span class="grey--text darken-1">
                    {{ subjectName }}
                    <!-- {{
                      subjects.find(item => item.id == reserveObject.subject_id)
                        .name
                    }}-->
                  </span>
                </p>
                <p class="main-color">
                  <strong>{{ $t("totalWebsiteFees") }} :</strong>
                  <span class="grey--text darken-1"
                    >{{ website_fees }} {{ $t("currency") }}</span
                  >
                </p>
                <p class="main-color">
                  <strong>{{ $t("totalLessonFees") }} :</strong>
                  <span class="grey--text darken-1"
                    >{{ parseInt(subjectTotalFees) }} {{ $t("currency") }}</span
                  >
                </p>
                <p class="main-color">
                  <strong>{{ $t("total") }} :</strong>
                  <span class="grey--text darken-1">
                    {{ parseInt(subjectTotalFees) }} +
                    {{ parseInt(website_fees) }} =
                    {{ parseInt(subjectTotalFees) + parseInt(website_fees) }}
                    {{ $t("currency") }}
                  </span>
                </p>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="modal-btn">
            <v-col cols="6" sm="6">
              <v-btn class="primary-btn text-right" @click="goBack" text>{{
                $t("back")
              }}</v-btn>
            </v-col>
            <v-col cols="6" sm="6" class="text-left">
              <v-btn class="primary-btn" text @click="confirm">{{
                $t("confirm")
              }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- success dialog -->
    <v-dialog v-model="confirmDialog" max-width="500">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="closeconfirmDialog()">
            <v-icon class="main-color">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color">
          {{ $t("confirmDialogTitle") }}
        </v-card-title>

        <div>
          <v-container style="padding: 1rem !important">
            <v-row>
              <v-col>
                <p class="text-center grey--text darken">
                  {{ successMessage }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="modal-btn">
            <v-col cols="6" sm="6"></v-col>
            <v-col cols="6" sm="6" class="text-left">
              <v-btn class="primary-btn" text @click="closeconfirmDialog">{{
                $t("confirm-btn")
              }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <editTeacherEvents
      :editDialog="editDialog"
      :eventObject="selectedEventObject"
      v-on:dialogClosed="closeDialog"
      v-on:updated="dataUpdated"
    ></editTeacherEvents>
    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import AUTH from "../auth";
import { validationMixin } from "../mixins/validationMixin";
import editTeacherEvents from "../components/editTeacherEvents";

export default {
  name: "CalendarComponent",
  mixins: [validationMixin],
  components: { editTeacherEvents },
  props: ["events"],
  data() {
    return {
      valid: false,
      focus: "",
      today: new Date().toISOString().substr(0, 10),
      scheduleMessage: "",
      successMessage: "",

      /* date picker */
      menu: false,
      modal: false,

      /* from date input */
      menu2: false,
      /* to date Input */
      menu1: false,

      selectedElement: null,
      selectedEvent: {},
      selectedOpen: false,

      selectSubjectDialog: false,
      confirmReservationDialog: false,
      confirmDialog: false,
      subjects: [],
      teacher: [],
      subjectsNamesAndFees: [],
      teacherID: "",
      reserveObject: {
        start: "",
        end: "",
        subject_id: "",
        teacher_schedule_id: "",
        notes: ""
      },
      minTime: "",
      maxTime: "",

      subjectName: "",
      hour_fees: "",
      original_website_fees: "",
      website_fees: "",
      subjectTotalFees: "",
      totalHours: 0,
      startItems: [],
      endItems: [],
      end_time_only: "",
      start_time_only: "",
      editDialog: false,
      selectedEventObject: {}
    };
  },
  methods: {
    dataUpdated(error, message) {
      if (error) {
        this.$refs.snack.sendErrorAlert(message);
      } else {
        this.$refs.snack.sendSuccessAlert(message);
        this.$emit("resetData");
      }
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getEventColor(event) {
      return event.color;
    },
    getSubjects() {
      this.$http
        .get(this.getApiUrl + "/teacher/subjects/" + this.teacherID, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            // console.log(response.data.data);
            this.subjects = response.data.data.subjects;
            this.teacher = response.data.data.teacher;
            this.subjectsNamesAndFees = response.data.data.subjectsNamesAndFees;
            this.original_website_fees = response.data.data.website_fees;
            this.website_fees = response.data.data.website_fees;
          }
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    showEvent({ nativeEvent, event }) {
      if (AUTH.type() == "Student" && event.color != "red") {
        this.scheduleMessage = "";
        this.selectSubjectDialog = true;
        this.getSubjects();
        this.reserveObject.teacher_schedule_id = event.id;
        this.reserveObject.start = event.start_time;
        this.reserveObject.end = event.end_time;
        this.minTime = event.start_time;
        this.maxTime = event.end_time;
        this.startItems = event.startItems;
        this.endItems = event.endItems;
        this.end_time_only = event.end_time_only;
        this.start_time_only = event.start_time_only;
      }
      if (AUTH.type() == "Teacher") {
        if (event.can_edit) {
          this.editDialog = true;
          this.selectedEventObject = event;
        } else {
          this.$refs.snack.sendErrorAlert(event.edit_msg);
        }
      }
    },
    confirm() {
      this.$http
        .post(
          this.getApiUrl + "/student/reservation/confirm/" + this.teacherID,
          this.reserveObject,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: this.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error) {
            this.scheduleMessage = response.data.status.message;
            this.selectSubjectDialog = true;
            this.confirmReservationDialog = false;
          } else {
            this.successMessage = response.data.status.message;
            this.confirmDialog = true;
            this.confirmReservationDialog = false;
            this.reserveObject = {
              start: "",
              end: "",
              subject_id: "",
              teacher_schedule_id: "",
              notes: ""
            };
          }
        });
    },

    goNext() {
      if (this.valid == false) {
        this.validate();
      } else {
        if (
          parseInt(this.reserveObject.end.substring(0, 2)) >
          parseInt(this.reserveObject.start.substring(0, 2))
        ) {
          this.selectSubjectDialog = false;
          this.confirmReservationDialog = true;
          this.scheduleMessage = "";

          this.subjectName = this.subjectsNamesAndFees[
            this.reserveObject.subject_id
          ].name;
          this.hour_fees = this.subjectsNamesAndFees[
            this.reserveObject.subject_id
          ].hour_price;
          this.totalHours =
            parseInt(this.reserveObject.end.substring(0, 2)) -
            parseInt(this.reserveObject.start.substring(0, 2));
          this.subjectTotalFees = this.totalHours * this.hour_fees;
          this.website_fees = this.original_website_fees;
          this.website_fees = this.totalHours * this.website_fees;
        } else {
          this.scheduleMessage = this.$i18n.t("from_to_error_message");
        }
      }
    },
    goBack() {
      this.selectSubjectDialog = true;
      this.confirmReservationDialog = false;
    },
    closeSelectSubjectDialog() {
      this.selectSubjectDialog = false;
      this.reset();
    },
    closeConfirmReservationDialog() {
      this.confirmReservationDialog = false;
      this.reset();
    },
    closeconfirmDialog() {
      this.confirmDialog = false;
    },
    reset() {
      this.reserveObject.subject_id = "";
      this.reserveObject.teacher_schedule_id = "";
      this.reserveObject.notes = "";

      this.subjectName = "";
      this.hour_fees = "";
      this.totalHours = 0;
      this.subjectTotalFees = "";
      this.website_fees = "";
    },
    closeDialog() {
      this.editDialog = false;
      this.selectedEventObject = {};
    }
  },
  mounted() {
    this.$refs.calendar.scrollToTime("08:00");
    if (AUTH.type() == "Student") {
      this.teacherID = this.$route.params.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-dialog {
  overflow-x: hidden !important;
  .container {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .teacher-image {
    max-width: 100px;
    max-height: 100px;
    margin: 0 auto !important;
    border-radius: 50%;
  }
  .col-sm-6,
  .col-12,
  .col-sm-12 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .primary-btn {
    width: auto !important;
  }
}

.display-flex {
  justify-content: center !important;
}
</style>
